import { Iusuario } from 'src/redux/api/types/auth';
import * as Yup from 'yup';

export const valoresInicialesActualizacionDatos: IactualizacionDatosForm = {
	usuarioId: '',
	tipoIdentificacion: '',
	identificacion: '',
	nombres: '',
	apellidos: '',
	correo: '',
	celular: '',
	correoAlterno: '',
	paisId: '',
	departamentoId: '',
	municipioId: '',
	direccionResidencia: '',
};

export const setValoresInicialesActualizacionDatos = (usuario: Iusuario) => {
	return {
		usuarioId: usuario.usuarioId,
		tipoIdentificacion: usuario.tipoIdentificacion,
		identificacion: usuario.identificacion,
		nombres: usuario.nombres,
		apellidos: usuario.apellidos,
		correo: usuario.correo,
		celular: usuario.celular,
		correoAlterno: '',
		paisId: usuario.paisId,
		departamentoId: usuario.departamentoId,
		municipioId: usuario.municipioId,
		direccionResidencia: usuario.direccionResidencia,
	}
  }

export const resetDapartamentoMunicipioResidencia = (valores: IactualizacionDatosForm) => {
	return {
		...valores,
		departamentoId: null,
		municipioId: null,
	}
}

export const esquemaDeValidacionActualizacionDatos = Yup.object({
	tipoIdentificacion: Yup.string().required('El tipo de identificación es obligatorio'),
	identificacion: Yup.string().required('La identificación es obligatoria'),
	nombres: Yup.string().required('El nombre es obligatorio'),
	apellidos: Yup.string().required('El apellido es obligatorio'),
	correo: Yup.string().email('El correo principal no es válido').required('El correo es obligatorio'),
	celular: Yup.string().matches(/^\d*$/, 'El celular debe contener solo números').required('El celular o teléfono es obligatorio'),
	correoAlterno: Yup.string().email('El correo alterno no es válido'),
	municipioId: Yup.string().required('El municipio de residencia es obligatorio'),
	direccionResidencia: Yup.string().required('La dirección de residencia es obligatoria'),
});


export interface IactualizacionDatosForm {
	usuarioId: string,
    tipoIdentificacion: string,
    identificacion: string,
    nombres: string,
    apellidos: string,
    correo: string,
    celular: string,
    correoAlterno: string,
	paisId: string,
	departamentoId: string,
    municipioId: string,
    direccionResidencia: string,
}

